import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Pagination({ currentPage, totalItems, itemsPerPage, onPageChange }) {
  const totalPages = Math.ceil(totalItems / itemsPerPage) || 1;
  
  if (totalPages <= 1) return null;

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginTop: '1.5rem', marginBottom: '1.5rem' }}>
      <button 
        className="btn btn-secondary btn-sm"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        style={{ padding: '0.4rem 0.8rem', background: 'var(--bg-surface)' }}
      >
        <ChevronLeft size={16} /> Anterior
      </button>
      
      <span style={{ fontSize: '0.9rem', fontWeight: 600, color: 'var(--text-muted)' }}>
        Página <span style={{ color: 'var(--primary)' }}>{currentPage}</span> de {totalPages}
      </span>
      
      <button 
        className="btn btn-secondary btn-sm"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        style={{ padding: '0.4rem 0.8rem', background: 'var(--bg-surface)' }}
      >
        Siguiente <ChevronRight size={16} />
      </button>
    </div>
  );
}
